define((require) => {
    "use strict";

    var ImprovedModel = require("shared/zbone/ImprovedModel");

    var GuidelineModel = ImprovedModel.extend("GuidelineModel", {
        defaults: {
            direction: null,
            position: null
        }
    }, {
        HORIZONTAL: "HORIZONTAL",
        VERTICAL: "VERTICAL"
    });

    return GuidelineModel;
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/guideline/GuidelineModel.js